var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "settings-engineers-threshold" } }, [
    _c(
      "form",
      {
        attrs: {
          id: "settings-engineers-threshold-form",
          "data-abide": "",
          novalidate: "",
        },
        on: {
          submit: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        _c("div", { staticClass: "threshold-controls clearfix" }, [
          _c("div", { staticClass: "float-left threshold-controls-header" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("settings.threshold.header")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _vm.aclHelper.getSettingsUpdateAccess()
            ? _c("div", { staticClass: "float-right" }, [
                !_vm.editView
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn--orange",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.editView = true
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.edit")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.editView
                  ? _c(
                      "button",
                      {
                        directives: [
                          { name: "hkldreset", rawName: "v-hkldreset" },
                        ],
                        staticClass: "btn btn--darkblue",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.discardChange()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.cancel")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.editView
                  ? _c(
                      "button",
                      {
                        directives: [
                          { name: "hkldreset", rawName: "v-hkldreset" },
                        ],
                        staticClass: "btn btn--orange",
                        attrs: { type: "button", disabled: _vm.disabled },
                        on: {
                          click: function ($event) {
                            return _vm.save()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.save")))]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("hr"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "threshold-value clearfix" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("settings.threshold.maxDocUploadSize"))),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.uploadFileSizeThreshold,
                expression: "uploadFileSizeThreshold",
              },
              { name: "hkldinput", rawName: "v-hkldinput" },
              {
                name: "fusioninputcheck",
                rawName: "v-fusioninputcheck",
                value: {
                  type: "integer",
                  pattern: /^\d{1,10}$/,
                  tip: _vm.$t("settings.threshold.hint", [1, 10]),
                },
                expression:
                  "{type: 'integer', pattern: /^\\d{1,10}$/, tip: $t('settings.threshold.hint', [1, 10])}",
              },
            ],
            staticClass:
              "settings-engineers-threshold-input settings-file-size-threshold",
            attrs: { type: "number", disabled: !_vm.editView, required: "" },
            domProps: { value: _vm.uploadFileSizeThreshold },
            on: {
              focus: function ($event) {
                _vm.showFileSizeHint = true
              },
              blur: function ($event) {
                _vm.showFileSizeHint = false
              },
              keyup: _vm.validate,
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.uploadFileSizeThreshold = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("settings.threshold.postMaxDocUploadSize"))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showFileSizeHint,
                expression: "showFileSizeHint",
              },
            ],
            staticClass: "file-size-hint-span",
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$i18n.t("settings.threshold.fileSizeHint")) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "threshold-value clearfix row" }, [
          _c("div", { staticClass: "file-upload-type" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("settings.threshold.fileUpLoadType")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.uploadFileTypesThreshold,
                expression: "uploadFileTypesThreshold",
              },
              { name: "hkldinput", rawName: "v-hkldinput" },
              { name: "autosize", rawName: "v-autosize" },
              {
                name: "fusioninputcheck",
                rawName: "v-fusioninputcheck",
                value: { type: "string", required: true },
                expression: "{type: 'string', required: true}",
              },
              {
                name: "checkVisibility",
                rawName: "v-checkVisibility",
                value: { refresh: true },
                expression: "{refresh: true}",
              },
            ],
            staticClass: "autosize threshold-file-type",
            attrs: { type: "text", disabled: !_vm.editView, required: "" },
            domProps: { value: _vm.uploadFileTypesThreshold },
            on: {
              keyup: _vm.validate,
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.uploadFileTypesThreshold = $event.target.value
              },
            },
          }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }